import { levelSelect } from "./levelSelect.js";
import { templateSelect } from "./templateSelect.js";
import { randomBtn } from "./randomBtn.js";
import { createElement } from "@/utils/create-elem.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import { config } from "@/utils/config.js";
import { appState } from "@/utils/state.js";
import { setLS } from "@/utils/local-storage.js";
import { randomGame } from "@/core/randomGame.js";
import { templateChange } from "@/core/templateChange.js";
import { levelChange } from "@/core/levelChange.js";

export function LevelBar(parent) {
  const levelBar = createElement({
    tag: "div",
    classes: ["level-bar"],
    parent: parent,
  });
  const selectLevelBar = createElement({
    tag: "div",
    classes: ["level-bar__item", "select-level-bar"],
    parent: levelBar,
  });

  createElement({
    tag: "p",
    text: "Choose a game:",
    parent: selectLevelBar,
  });

  levelSelect(selectLevelBar);

  setLS("matrix", appState.getState("matrix"));

  levelChange();
  templateChange();

  randomBtn(levelBar);
  randomGame();
}
